import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login/Login";
import NotFound from "./Pages/NotFound";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import Version from "./Pages/Version/Version";
import Help from "./Pages/Help/Help";
import UserManagement from "./Pages/UserManagement/UserManagement";
import AllLicenses from "./Pages/AllLicenses/AllLicenses";
import Settings from "./Pages/Settings/Settings";

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/user-management"
          element={
            <PrivateRoute requireCustomer={true}>
              <UserManagement />
            </PrivateRoute>
          }
        />

        <Route
          path="/version"
          element={
            <PrivateRoute>
              <Version />
            </PrivateRoute>
          }
        />
        <Route
          path="/help"
          element={
            <PrivateRoute>
              <Help />
            </PrivateRoute>
          }
        />
        <Route 
          path="/license-overview"
          element={
            <PrivateRoute requireSuperAdmin={true}>
              <AllLicenses />
            </PrivateRoute>
          }
        />
        <Route 
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
